import { IDemoAttributionParams } from '@aqx-core/common/api/account';
import { EPasswordType } from '@aqx-core/common/api/account-link';
import { ELoginSource } from '@aqx-core/common/api/auth';
import { TAppLanguageISOCountryCode } from '@aqx-core/common/i18n';

import { ELoginConfigType, EMainProductCodeType } from '../../config';

export enum EBaseCurrency {
  ALL = 'ALL',
  AFN = 'AFN',
  ARS = 'ARS',
  AWG = 'AWG',
  AUD = 'AUD',
  AZN = 'AZN',
  BSD = 'BSD',
  BBD = 'BBD',
  BYN = 'BYN',
  BZD = 'BZD',
  BMD = 'BMD',
  BOB = 'BOB',
  BAM = 'BAM',
  BWP = 'BWP',
  BGN = 'BGN',
  BRL = 'BRL',
  BND = 'BND',
  KHR = 'KHR',
  CAD = 'CAD',
  KYD = 'KYD',
  CLP = 'CLP',
  CNY = 'CNY',
  COP = 'COP',
  CRC = 'CRC',
  HRK = 'HRK',
  CUP = 'CUP',
  CZK = 'CZK',
  DKK = 'DKK',
  DOP = 'DOP',
  XCD = 'XCD',
  EGP = 'EGP',
  SVC = 'SVC',
  EUR = 'EUR',
  FKP = 'FKP',
  FJD = 'FJD',
  GHS = 'GHS',
  GIP = 'GIP',
  GTQ = 'GTQ',
  GGP = 'GGP',
  GYD = 'GYD',
  HNL = 'HNL',
  HKD = 'HKD',
  HUF = 'HUF',
  ISK = 'ISK',
  INR = 'INR',
  IDR = 'IDR',
  IRR = 'IRR',
  IMP = 'IMP',
  ILS = 'ILS',
  JMD = 'JMD',
  JPY = 'JPY',
  JEP = 'JEP',
  KZT = 'KZT',
  KPW = 'KPW',
  KRW = 'KRW',
  KGS = 'KGS',
  LAK = 'LAK',
  LBP = 'LBP',
  LRD = 'LRD',
  MKD = 'MKD',
  MYR = 'MYR',
  MUR = 'MUR',
  MXN = 'MXN',
  MNT = 'MNT',
  MZN = 'MZN',
  NAD = 'NAD',
  NPR = 'NPR',
  ANG = 'ANG',
  NZD = 'NZD',
  NIO = 'NIO',
  NGN = 'NGN',
  NOK = 'NOK',
  OMR = 'OMR',
  PKR = 'PKR',
  PAB = 'PAB',
  PYG = 'PYG',
  PEN = 'PEN',
  PHP = 'PHP',
  PLN = 'PLN',
  QAR = 'QAR',
  RON = 'RON',
  RUB = 'RUB',
  SHP = 'SHP',
  SAR = 'SAR',
  RSD = 'RSD',
  SCR = 'SCR',
  SGD = 'SGD',
  SBD = 'SBD',
  SOS = 'SOS',
  ZAR = 'ZAR',
  LKR = 'LKR',
  SEK = 'SEK',
  CHF = 'CHF',
  SRD = 'SRD',
  SYP = 'SYP',
  TWD = 'TWD',
  THB = 'THB',
  TTD = 'TTD',
  TRY = 'TRY',
  TVD = 'TVD',
  UAH = 'UAH',
  GBP = 'GBP',
  USD = 'USD',
  UYU = 'UYU',
  UZS = 'UZS',
  VEF = 'VEF',
  VND = 'VND',
  YER = 'YER',
  ZWD = 'ZWD'
}

export const CurrencySymbol: Record<EBaseCurrency, string> = {
  [EBaseCurrency.ALL]: 'Lek',
  [EBaseCurrency.AFN]: '؋',
  [EBaseCurrency.ARS]: '$',
  [EBaseCurrency.AWG]: 'ƒ',
  [EBaseCurrency.AUD]: '$',
  [EBaseCurrency.AZN]: '₼',
  [EBaseCurrency.BSD]: '$',
  [EBaseCurrency.BBD]: '$',
  [EBaseCurrency.BYN]: 'Br',
  [EBaseCurrency.BZD]: 'BZ$',
  [EBaseCurrency.BMD]: '$',
  [EBaseCurrency.BOB]: '$b',
  [EBaseCurrency.BAM]: 'KM',
  [EBaseCurrency.BWP]: 'P',
  [EBaseCurrency.BGN]: 'лв',
  [EBaseCurrency.BRL]: 'R$',
  [EBaseCurrency.BND]: '$',
  [EBaseCurrency.KHR]: '៛',
  [EBaseCurrency.CAD]: '$',
  [EBaseCurrency.KYD]: '$',
  [EBaseCurrency.CLP]: '$',
  [EBaseCurrency.CNY]: '¥',
  [EBaseCurrency.COP]: '$',
  [EBaseCurrency.CRC]: '₡',
  [EBaseCurrency.HRK]: 'kn',
  [EBaseCurrency.CUP]: '₱',
  [EBaseCurrency.CZK]: 'Kč',
  [EBaseCurrency.DKK]: 'kr',
  [EBaseCurrency.DOP]: 'RD$',
  [EBaseCurrency.XCD]: '$',
  [EBaseCurrency.EGP]: '£',
  [EBaseCurrency.SVC]: '$',
  [EBaseCurrency.EUR]: '€',
  [EBaseCurrency.FKP]: '£',
  [EBaseCurrency.FJD]: '$',
  [EBaseCurrency.GHS]: '¢',
  [EBaseCurrency.GIP]: '£',
  [EBaseCurrency.GTQ]: 'Q',
  [EBaseCurrency.GGP]: '£',
  [EBaseCurrency.GYD]: '$',
  [EBaseCurrency.HNL]: 'L',
  [EBaseCurrency.HKD]: '$',
  [EBaseCurrency.HUF]: 'Ft',
  [EBaseCurrency.ISK]: 'kr',
  [EBaseCurrency.INR]: '₹',
  [EBaseCurrency.IDR]: 'Rp',
  [EBaseCurrency.IRR]: '﷼',
  [EBaseCurrency.IMP]: '£',
  [EBaseCurrency.ILS]: '₪',
  [EBaseCurrency.JMD]: 'J$',
  [EBaseCurrency.JPY]: '¥',
  [EBaseCurrency.JEP]: '£',
  [EBaseCurrency.KZT]: 'лв',
  [EBaseCurrency.KPW]: '₩',
  [EBaseCurrency.KRW]: '₩',
  [EBaseCurrency.KGS]: 'лв',
  [EBaseCurrency.LAK]: '₭',
  [EBaseCurrency.LBP]: '£',
  [EBaseCurrency.LRD]: '$',
  [EBaseCurrency.MKD]: 'ден',
  [EBaseCurrency.MYR]: 'RM',
  [EBaseCurrency.MUR]: '₨',
  [EBaseCurrency.MXN]: '$',
  [EBaseCurrency.MNT]: '₮',
  [EBaseCurrency.MZN]: 'MT',
  [EBaseCurrency.NAD]: '$',
  [EBaseCurrency.NPR]: '₨',
  [EBaseCurrency.ANG]: 'ƒ',
  [EBaseCurrency.NZD]: '$',
  [EBaseCurrency.NIO]: 'C$',
  [EBaseCurrency.NGN]: '₦',
  [EBaseCurrency.NOK]: 'kr',
  [EBaseCurrency.OMR]: '﷼',
  [EBaseCurrency.PKR]: '₨',
  [EBaseCurrency.PAB]: 'B/.',
  [EBaseCurrency.PYG]: 'Gs',
  [EBaseCurrency.PEN]: 'S/.',
  [EBaseCurrency.PHP]: '₱',
  [EBaseCurrency.PLN]: 'zł',
  [EBaseCurrency.QAR]: '﷼',
  [EBaseCurrency.RON]: 'lei',
  [EBaseCurrency.RUB]: '₽',
  [EBaseCurrency.SHP]: '£',
  [EBaseCurrency.SAR]: '﷼',
  [EBaseCurrency.RSD]: 'Дин.',
  [EBaseCurrency.SCR]: '₨',
  [EBaseCurrency.SGD]: '$',
  [EBaseCurrency.SBD]: '$',
  [EBaseCurrency.SOS]: 'S',
  [EBaseCurrency.ZAR]: 'R',
  [EBaseCurrency.LKR]: '₨',
  [EBaseCurrency.SEK]: 'kr',
  [EBaseCurrency.CHF]: 'CHF',
  [EBaseCurrency.SRD]: '$',
  [EBaseCurrency.SYP]: '£',
  [EBaseCurrency.TWD]: 'NT$',
  [EBaseCurrency.THB]: '฿',
  [EBaseCurrency.TTD]: 'TT$',
  [EBaseCurrency.TRY]: '₺',
  [EBaseCurrency.TVD]: '$',
  [EBaseCurrency.UAH]: '₴',
  [EBaseCurrency.GBP]: '£',
  [EBaseCurrency.USD]: '$',
  [EBaseCurrency.UYU]: '$U',
  [EBaseCurrency.UZS]: 'лв',
  [EBaseCurrency.VEF]: 'Bs',
  [EBaseCurrency.VND]: '₫',
  [EBaseCurrency.YER]: '﷼',
  [EBaseCurrency.ZWD]: 'Z$'
};

export enum EAccountType {
  LIVE = 'LIVE',
  DEMO = 'DEMO'
}

export enum EAccountDisplayType {
  MASTER = 'MASTER',
  LIVE = 'LIVE',
  VIRTUAL = 'VIRTUAL',
  DEMO = 'DEMO'
}

export enum ESimple2TradeAccountType {
  DEMO = 'DEMO',
  LIVE = 'LIVE',
  COPY_F = 'COPY_F',
  COPY_M = 'COPY_M',
  MAM = 'MAM',
  PAMM = 'PAMM',
  INV = 'INV'
}

export enum ETradingState {
  NEUTRAL = 'NEUTRAL',
  MARGIN_CALL = 'MARGIN_CALL',
  STOPPED_OUT = 'STOPPED_OUT',
  REACHED_NOP = 'REACHED_NOP',
  LIQUIDATION = 'LIQUIDATION'
}

export enum ECrmType {
  SIMPLE2TRADE = 'SIMPLE2TRADE',
  STONEINNO = 'STONEINNO',
  FXCRM = 'FXCRM',
  TRADAWISE = 'TRADEWISE'
}

export enum ECrmKYCStatus {
  PENDING_KYC = 'PENDING_KYC',
  VERIFYING_KYC = 'VERIFYING_KYC',
  KYC_REJECTED = 'KYC_REJECTED',
  KYC_VERIFIED = 'KYC_VERIFIED'
}

export interface ISwitchMetatraderAccountParams {
  metatraderId: number;
  passwordType?: EPasswordType;
  serverId?: number;
}

export interface IDemoAccountCreationV1Params {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber?: string;
  name?: string;
}

export interface ILogoutDevicesParams {
  sources?: ELoginSource;
  loginTime: string[];
}

export interface IUserDetail {
  tradingAccounts: ITradingAccount[];
  crmType: ECrmType;
  crmKYCStatus: ECrmKYCStatus | null;
  loginConfig: ELoginConfigType;
  notificationTopics: string[];
}

export interface ITradingAccount {
  accountId: string;
  userId: string;
  clientId: string;
  userGroup: string;
  accountName?: string;
  accountNumber: number;
  baseCurrency: EBaseCurrency;
  isDemo: boolean;
  platform: string;
  isVirtual: boolean;
  realizedPL: number;
  unRealizedPL: number;
  strategy: string;
  balance: number;
  margin: number;
  equity: number;
  profitLoss: number;
  freeMargin: number;
  marginLevel: number;
  traderId: string;
  traderSubscription: string;
  marketSubcription: string;
  metatraderId: number;
  accountType: EAccountType;
  accountDisplayType: EAccountDisplayType;
  accountTypeName: string;
  simple2TradeAccountType: ESimple2TradeAccountType;
  canSwitch: boolean;
  leverage: number;
  readOnly: number;
  lastVerifiedDate: number;
  language: TAppLanguageISOCountryCode | null;
  marginCall: number;
  marginStopout: number;
  pnlGross: number;
  buyingPower: number;
  sellingPower: number;
  notional: number;
  commission: number;
  swaps: number;
  availableWithdraw: number;
  credit: number;
  tradingState: ETradingState;
  serverId: number;
  mainProductCode: EMainProductCodeType;
  omsServerId: string;
  selected: boolean;
  enable: boolean;
  dealer: string;
  viewOnly: boolean;
}

export interface ISwitchMetatraderAccount {
  virtualAccountId: number;
  strategy: string;
  balance: number;
  realizedProfitLost: number;
  unrealizedProfitLost: number;
  currency: string;
  platform: string;
  metatraderGroup: string;
  metatraderId: number;
  traderSubcription: string;
  marketSubcription: string;
  switchedAccountToken: string;
  virtual: boolean;
  demo: boolean;
}

export interface IActiveSessionDevice {
  loginSource: ELoginSource;
  lastActivity: number;
  ipAddress: string;
  deviceType: string;
  browserType: string;
  loginTime: string;
  active: boolean;
}

export interface IDemoSignUpParams {
  depositAmount: number;
  email: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  country: string;
  loginSource?: ELoginSource;
  appsFlyerAttribute?: IDemoAttributionParams;
  marketingPageUrl?: string;
  language?: string;
}

export interface IDemoAccountCreation {
  login: string;
  name: string;
  email: string;
  investorPassword: string;
  password: string;
  userGroup: string;
  deposit: number;
  leverage: number;
  currency: string;
  serverName: string;
  phoneNumber: string;
}
